import { useContext } from "react";
import { rootContext } from "../contexts/rootContext";

interface SupaLinkProps {
  text: string;
  handleClick: ()=>void;
  textSize?: string;
  textColor?: string;
  style?: React.CSSProperties
}

function SupaLink(props: SupaLinkProps) {
  const context = useContext(rootContext);
  
  const handleClick = (_event: React.MouseEvent<HTMLElement>) => {
    props.handleClick();
  };

  const breathFontStyle: React.CSSProperties = {
    fontSize: props.textSize ?? "24px",
    textAlign: "center",
    alignContent: "center",
    animation: "letter-breathe 1s ease-in-out infinite",
    color: props.textColor ?? context.theme.text.contrast2,
    transition: context.theme.transitions.color,
    textDecoration: "underline",
    cursor: `url(${context.theme.cursor.pointer}), pointer`,
    ...props.style
  }

  return (
    <span style={breathFontStyle} onClick={handleClick}>      
      {props.text}
    </span>);
}

export default SupaLink;
